import { Download } from "@mui/icons-material";
import { Grid2 } from "@mui/material";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import { useWorker } from "../../../../../../Hooks/useWorker";
import { forceRescanId } from "../../../../../Reports/Actions/forceRescan";
import ActionButton from "../../../../../UI/BasicLayout/Components/FilterPlusActions/ActionButton";
import exportFiles from "../../../../Actions/exportFiles";
// import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
// import { forceRescanId } from "../../../../../Reports/Actions/forceRescan";
// import ActionButton from "../../../../../UI/BasicLayout/Components/FilterPlusActions/ActionButton";
// import exportFiles from "../../../../Actions/exportFiles";
// import { useWorker } from "../../../../../../Hooks/useWorker";

const UIText = {
  "es-CL": { label: "Exportar" },
  "en-US": { label: "Export" },
};

const Export = ({ allFiles }) => {
  const { dispatch, settings } = useUIBp();
  const { working } = useWorker(forceRescanId);

  const onClick = () => {
    dispatch(exportFiles({ allFiles, locale: settings.locale }));
  };

  console.log("export allfiles", allFiles);

  return (
    <Grid2 container size={2.5}>
      <ActionButton
        {...{
          working,
          onClick,
          UIText,
          icon: <Download />,
          variant: "outlined",
          size: 12,
        }}
      />
    </Grid2>
  );
};

export default Export;
